/**
 * Utility functions for poll-related operations
 */

import { PollsResponse, TeamPollRank } from "../types/poll";

/**
 * Extracts poll rankings for a specific team from polls data
 * @param teamSchool - The school name of the team to get rankings for
 * @param pollsData - The polls data containing all poll rankings
 * @returns Array of poll rankings for the team
 */
export const getTeamPollRank = (
  teamSchool: string,
  pollsData: PollsResponse | null
): TeamPollRank => {
  if (!pollsData || !pollsData.polls) return [];
  const results: { poll: string; rank: number }[] = [];
  for (const pollKey of Object.keys(pollsData.polls)) {
    const poll = pollsData.polls[pollKey];
    if (poll && Array.isArray(poll.ranks)) {
      for (const rankObj of poll.ranks) {
        if (
          rankObj.school &&
          rankObj.school.toLowerCase() === teamSchool.toLowerCase()
        ) {
          results.push({ poll: pollKey, rank: rankObj.rank });
        }
      }
    }
  }
  return results;
};

// Helper function to get the best poll rank based on priority
export const getBestPollRank = (pollRanks: TeamPollRank): number | null => {
  if (pollRanks.length === 0) return null;
  if (pollRanks.length === 1) return pollRanks[0].rank;

  // Priority order: CFP > AP Top 25 > Coaches Poll > first available
  const priorityOrder = [
    "College Football Playoff Rankings",
    "AP Top 25",
    "Coaches Poll",
  ];

  for (const priorityPoll of priorityOrder) {
    const found = pollRanks.find((pr) => pr.poll === priorityPoll);
    if (found) return found.rank;
  }

  // If none of the priority polls are found, return the first one
  return pollRanks[0].rank;
};
